<template>
  <div>
  <base-card>
    <v-card-text>
      <div class="d-flex flex-column align-center justify-center text-center py-6">
        <h3 class="mb-8">Descarga XMLS</h3>
      </div>

      <!-- Tabs para seleccionar tipo de filtro -->
      <v-row justify="center" class="mb-8">
        <v-col cols="12" sm="8">
          <v-tabs
            v-model="activeTab"
            grow
            background-color="transparent"
            color="primary"
          >
            <v-tab key="consecutivos">
              <v-icon left>mdi-file-document</v-icon>
              Por Consecutivos
            </v-tab>
            <v-tab key="fechas">
              <v-icon left>mdi-calendar-range</v-icon>
              Por Rango de Fechas
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <!-- Campos de fechas arriba cuando está activo el tab de fechas -->
      <v-row justify="center" v-show="activeTab === 1">
        <v-col cols="12" sm="6">
          <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="dataFilter.dates"
                persistent
                width="290px"
              >
                <template v-slot:activator="{on, attrs}">
                  <v-text-field
                    v-model="dataFilter.dates"
                    label="Seleccionar rango de fechas"
                    prepend-inner-icon="mdi-calendar-range"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dataFilter.dates"
                  range
                  :min="minDate"
                  :max="maxDate"
                  locale="es"
                >
                  <v-spacer />
                  <v-btn
                    text
                    style="background-color:rgb(204 33 40);color:white !important"
                    @click="modal = false"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    text
                    style="background-color:rgb(204 33 40);color:white !important"
                    @click="$refs.dialog.save(dataFilter.dates)"
                  >
                    Aplicar
                  </v-btn>
                </v-date-picker>
              </v-dialog>
        </v-col>
      </v-row>

      <!-- Selector de compañía y tipo -->
      <v-row justify="center" :class="activeTab === 1 ? 'mt-4' : ''">
        <v-col cols="12" sm="4">
          <v-select
            ref="cliente"
            v-model="dataFilter.IdCompania"
            :items="filteredClients"
            item-text="text"
            item-value="IdCompania"
            label="Selecciona una compañía"
            prepend-inner-icon="mdi-sitemap"
            required
            dense
            outlined
            :disabled="isGeneralAdmin"
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-text-field
                      v-model="search"
                      placeholder="Buscar"
                      prepend-inner-icon="mdi-magnify"
                      hide-details
                      dense
                    />
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </v-col>

        <v-col cols="12" sm="4">
          <v-select
            v-model="dataFilter.Tipo"
            :items="tiposDocumento"
            item-text="textStatus"
            item-value="valueStatus"
            label="Tipo de XML"
            prepend-inner-icon="mdi-order-bool-descending-variant"
            dense
            outlined
            :clearable="!isGeneralAdmin"
            :disabled="isGeneralAdmin"
          />
        </v-col>
      </v-row>

      <!-- Campo de consecutivos - solo visible en tab de consecutivos -->
      <v-row justify="center" class="mt-4" v-show="activeTab === 0">
        <v-col cols="12" sm="6">
          <v-textarea
            v-model="dataFilter.Consecutivos"
            label="Consecutivos (separados por coma)"
            prepend-inner-icon="mdi-file-document"
            dense
            outlined
            required
            placeholder="Ej: FE123,FE124,FE130"
            rows="1"
            auto-grow
          />
        </v-col>
      </v-row>



      <v-row justify="center">
        <v-col cols="12" sm="3"></v-col>
          <v-col cols="12" sm="3">

          <v-btn
            :disabled="isLoading"
            :loading="isLoading"
            class="ma-2"
            style="background-color: rgb(204 33 40); color: white !important;"
            @click="descargarXMLs"
            block
          >
            <v-icon left>mdi-download</v-icon>
            Descargar XMLs
          </v-btn>
        </v-col>

        <v-col cols="12" sm="4">

          <v-btn
            :disabled="isLoading"
            class="ma-2"
            color="gray"
            @click="clearFields"
          >
            Limpiar
          </v-btn>
        </v-col>

      </v-row>
      <v-row justify="center" class="my-4">
        <v-progress-linear
          v-if="isLoading"
          class="my-4"
          color="primary"
          indeterminate
        ></v-progress-linear>
        <v-col cols="12" sm="6">
          <v-alert
            v-if="showAlert"
            :type="alertType"
            dense
            outlined
            border="left"
            colored-border
            class="my-4"
          >
            {{ alertMessage }}
          </v-alert>

        </v-col>
      </v-row>
    </v-card-text>
  </base-card>


  </div>
</template>

<script>
import axios from 'axios';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { environment } from '@/data/environment';
import { listStatusXml } from '@/data/listStatus';

export default {
  data() {
    return {
      detailClients: [],
      dataFilter: {
        IdCompania: null,
        Consecutivos: '',
        Tipo: '',
        dates: [],
      },
      activeTab: 0,
      modal: false,
      search: '',
      dateRange: [],
      dateMenu: false,
      tiposDocumento: listStatusXml,
      isLoading: false,
      showAlert: false,
      alertMessage: '',
      alertType: 'success',
      userInfo: null,
      isGeneralAdmin: false,
    };
  },
  mounted() {
    this.getUserInfo();
    this.obtenerCompanias();
  },
  computed: {
    filteredClients() {
      const query = this.search.toLowerCase();
      return this.detailClients.filter(c =>
        c.text.toLowerCase().includes(query)
      );
    },
    minDate() {
      const today = new Date();
      const thirtyDaysAgo = new Date(today);
      thirtyDaysAgo.setDate(today.getDate() - 60);
      return thirtyDaysAgo.toISOString().split('T')[0];
    },
    maxDate() {
      return new Date().toISOString().split('T')[0];
    },
  },
  methods: {
    getUserInfo() {
      try {
        const uid = localStorage.getItem('uid');
        if (uid) {
          this.userInfo = JSON.parse(atob(uid));
          const rol = JSON.parse(localStorage.getItem('role') || "[]")
          this.isGeneralAdmin = rol.includes('General-Admin') || rol.includes('General')
          // Si es General-Admin, establecer valores por defecto
          if (this.isGeneralAdmin) {
            this.dataFilter.IdCompania = this.userInfo.idcompania;
            this.dataFilter.Tipo = 'autorizado'; // XML Autorizados por defecto
          }
        }
      } catch (error) {
        console.error('Error al obtener información del usuario:', error);
      }
    },

    async obtenerCompanias() {
      try {
        const response = await axios.get(environment.HIOPOSWEBSERVICES + '/getClientsForXML');
        
        let companies = response.data.Mensaje;
        
        // Si es General-Admin, filtrar solo su compañía
        if (this.isGeneralAdmin && this.userInfo.idcompania) {
          companies = companies.filter(c => c.id === this.userInfo.idcompania);
        }
        
        this.detailClients = companies.map(c => ({
          text: " [ " + c.id +  " ] " +  c.name,
          IdCompania: c.id,
        }));
      } catch (error) {
        console.error('Error al obtener compañías:', error);
      }
    },

    async descargarXMLs() {
      this.resetAlert();
      if (!this.dataFilter.IdCompania) {
        this.setAlert('warning', 'Por favor selecciona una compañía.');
        return;
      }

      if (!this.dataFilter.Tipo) {
        this.setAlert('warning', 'Por favor selecciona un tipo de XML.');
        return;
      }
      // Preparar datos para el envío
      let requestData = {
        compania: this.dataFilter.IdCompania,
        tipoXML: this.dataFilter.Tipo,
      };

      if (this.activeTab === 0) {
        // Validación y preparación para búsqueda por consecutivos
        const consecutivos = this.dataFilter.Consecutivos
          .split(',')
          .map(c => c.trim())
          .filter(Boolean);

        if (consecutivos.length === 0) {
          this.setAlert('warning', 'Por favor escribe al menos un consecutivo.');
          return;
        }

        if (consecutivos.length > 30) {
          this.setAlert('warning', 'Solo se permiten hasta 30 consecutivos.');
          return;
        }

        requestData.consecutivos = consecutivos;
      } else {
        // Validación y preparación para búsqueda por rango de fechas
        if (!this.dataFilter.dates || this.dataFilter.dates.length !== 2) {
          this.setAlert('warning', 'Por favor selecciona un rango de fechas válido.');
          return;
        }

        const [fechaDesde, fechaHasta] = this.dataFilter.dates.sort();
        if (new Date(fechaDesde) > new Date(fechaHasta)) {
          this.setAlert('warning', 'La fecha de inicio debe ser anterior a la fecha final.');
          return;
        }

        requestData.fechaDesde = fechaDesde;
        requestData.fechaHasta = fechaHasta;
      }

      this.isLoading = true;

      try {

        const response = await axios.post(`${environment.HIOPOSWEBSERVICES}/getXMLS`, requestData);

        const data = response.data.respuesta;
        if (data.Error || !Array.isArray(data.Datos)) {
          throw new Error('Respuesta inválida del servidor.');
        }

        const zip = new JSZip();

        data.Datos.forEach((item, index) => {
          const nombre = item.consecutive || `archivo_${index + 1}`;
          if (item.xml) zip.file(`${nombre}.xml`, item.xml);
        });

        if (Object.keys(zip.files).length === 0) {
          this.setAlert('warning', 'No se encontraron resultados para los datos proporcionados.');
          return;
        }

        const blob = await zip.generateAsync({ type: 'blob' });
        const now = new Date().toISOString().split('.')[0].replace(/[-:T]/g, '');
        saveAs(blob, `xmls_${this.dataFilter.IdCompania}_${now}.zip`);

        this.setAlert('success', 'La descarga se realizó exitosamente.');
        
        // Solo limpiar campos específicos, preservar configuración de General-Admin
        if (this.isGeneralAdmin) {
          // Para General-Admin solo limpiar consecutivos y fechas
          this.dataFilter.Consecutivos = '';
          this.dataFilter.dates = [];
          this.modal = false;
        } else {
          // Para otros roles limpiar todo
          this.clearFields();
        }

      } catch (error) {
        console.error('Error al descargar XMLs:', error);
        this.setAlert('error', 'Ocurrió un error durante la descarga.');
      } finally {
        this.isLoading = false;
      }
    },

    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },

    resetAlert() {
      this.alertMessage = '';
      this.alertType = 'success';
      this.showAlert = false;
    },

    clearFields() {
      this.dataFilter = {
        IdCompania: null,
        Consecutivos: '',
        Tipo: '',
        dates: [],
      };
      this.search = '';
      this.modal = false;
    },
  },
};
</script>
